import { UIText2 } from '@cian/ui-kit';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './style.css';
import { NBSP } from '../../constants/text';

export const BookedOfferDescription = () => {
  return (
    <div className={styles['container']} data-testid="booked-offer-description">
      <div className={styles['icon']}>
        <IconFunctionalLock16 display="block" color="decorative-magentum" />
      </div>
      <UIText2 as="p" color="decorative-magentum">
        Забронирована, но{NBSP}может освободиться
      </UIText2>
    </div>
  );
};
